import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const DownvoteIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 24 24",
    },
    <g clipPath="url(#downvote_svg__a)">
      <path
        fill="#373F51"
        fillRule="evenodd"
        d="M7 18.889a8 8 0 0 1 .845-3.578L8 15H3.127a3 3 0 0 1-2.904-3.753L2.75 1.5H22a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.763l-2.247 2.134a8 8 0 0 0-2.49 5.8V22.5H10a3 3 0 0 1-3-3zm10-6.283-2.043 1.941A9.5 9.5 0 0 0 12.01 21H10a1.5 1.5 0 0 1-1.5-1.5v-.611a6.5 6.5 0 0 1 .686-2.907l1.241-2.482h-7.3a1.5 1.5 0 0 1-1.452-1.876L3.911 3H17zM18.5 12H22a.5.5 0 0 0 .5-.5v-8A.5.5 0 0 0 22 3h-3.5z"
        clipRule="evenodd"
      />
    </g>,
    <defs>
      <clipPath id="downvote_svg__a">
        <path fill="#fff" d="M24 24H0V0h24z" />
      </clipPath>
    </defs>
  );
